import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import zeplinColor from 'theme/Color';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

interface BasicTabItem {
  id: number;
  label: string;
  Component: React.ReactNode;
  isHidden: boolean;
}

interface BasicTabProps {
  tabs: BasicTabItem[];
  handleChange: (event: React.SyntheticEvent, newValue: number) => void;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0, overflow: 'auto' }}
    >
      {value === index && (
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function BasicTab({ tabs, handleChange, value }: BasicTabProps) {
  return (
    <Box
      sx={{
        width: '100%',
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: { xs: '12px', xl: '16px' },
        position: 'relative',
        minHeight: 0,
      }}
    >
      <Box sx={{ borderBottom: 1, borderColor: zeplinColor.Neutral5 }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label='basic tabs'
          sx={{
            '& .MuiTabs-indicator': {
              backgroundColor: zeplinColor.BasicBlack,
            },
            '& .MuiTab-root': {
              textTransform: 'none',
              color: zeplinColor.Neutral8,
              fontWeight: 400,
              padding: '12px 16px',
              minHeight: '0px',
              '@media (min-width:1700px)': {
                padding: '15px 20px',
                fontSize: '14px',
              },
            },
            '& .Mui-selected': {
              color: `${zeplinColor.BasicBlack} !important`,
              fontWeight: 500,
            },
            '&.MuiTabs-root': {
              minHeight: '32px',
            },
          }}
        >
          {tabs.map((tab) => (
            <Tab key={tab.id} label={tab.label} {...a11yProps(tab.id)} />
          ))}
        </Tabs>
      </Box>

      {tabs.map(
        ({ Component }, i) =>
          !tabs[i].isHidden && (
            <CustomTabPanel value={value} index={i} key={i}>
              {Component}
            </CustomTabPanel>
          ),
      )}
    </Box>
  );
}
